import request from "@/utils/request";
import URL from "@/api/baseUrl";

const basePath = `${URL.vip}/marketing/banner`;

export default class MarketingBanner {
  static list(params = {}) {
    return request.get(`${basePath}/list`, params);
  }
}
